import React from 'react';
import { Card, CardContent } from '../../components/ui/card';
import { Users, BookOpen, Award, Clock } from 'lucide-react';

export const InhaberStatsBanner = ({ companyName, stats = {} }) => (
  <>
    <Card className="bg-gradient-to-r from-yellow-500/10 to-transparent border-yellow-500/30 mb-8">
      <CardContent className="py-6">
        <p className="text-2xl font-bold text-white">
          Willkommen im Cockpit der <span className="text-yellow-500">SmartVolt-Revolution</span>
          {companyName ? `, ${companyName.split(' ')[0]}!` : '!'}
        </p>
        <p className="text-gray-400 mt-2">
          Dein Betrieb hat <span className="text-yellow-500 font-bold">{stats.totalCompletedCourses || 0}</span> Schulungen erfolgreich abgeschlossen.
        </p>
      </CardContent>
    </Card>

    <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-8">
      <Card className="bg-gray-900/50 border-gray-800">
        <CardContent className="pt-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-400">Mitarbeiter</p>
              <p className="text-3xl font-bold text-white">{stats.totalEmployees || 0}</p>
            </div>
            <Users className="h-10 w-10 text-yellow-500/50" />
          </div>
        </CardContent>
      </Card>
      <Card className="bg-gray-900/50 border-gray-800">
        <CardContent className="pt-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-400">Aktive Kurse</p>
              <p className="text-3xl font-bold text-white">{stats.totalActivatedCourses || 0}</p>
            </div>
            <BookOpen className="h-10 w-10 text-blue-500/50" />
          </div>
        </CardContent>
      </Card>
      <Card className="bg-gray-900/50 border-gray-800">
        <CardContent className="pt-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-400">Abgeschlossen</p>
              <p className="text-3xl font-bold text-white">{stats.totalCompletedCourses || 0}</p>
            </div>
            <Award className="h-10 w-10 text-green-500/50" />
          </div>
        </CardContent>
      </Card>
      <Card className="bg-gray-900/50 border-gray-800">
        <CardContent className="pt-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-400">Ausstehend</p>
              <p className="text-3xl font-bold text-white">{stats.pendingRequestsCount || 0}</p>
            </div>
            <Clock className="h-10 w-10 text-orange-500/50" />
          </div>
        </CardContent>
      </Card>
    </div>
  </>
);
